import type { HotelPictureView, HotelRoomPhotos } from './api';
import { searchKey } from './sales-catalogue';

/** Ürün Sahibi, 03.10.2026: alt alta en çok altı kart, gerisi sayfada. */
export const ROOM_PAGE_SIZE = 6;

/**
 * Teklifteki oda tipinin karesi. Tedarikçinin oda adı ile ürün ağacındaki oda tipi adı aynı
 * kaynaktan gelse de büyük-küçük harf ve boşluk farkı taşıyabiliyor; ikisi aynı anahtara
 * indirgenip karşılaştırılıyor, bulunamazsa otelin kapak karesi kullanılıyor.
 */
export function roomPicture(photos: HotelRoomPhotos | null, roomTypes: readonly string[]): HotelPictureView | null {
  if (!photos) return null;
  const key = (value: string) => searchKey(value).replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  for (const roomType of roomTypes) {
    const wanted = key(roomType);
    const exact = photos.rooms.find(room => key(room.name) === wanted && room.photos[0]);
    if (exact?.photos[0]) return exact.photos[0];
    const partial = photos.rooms.find(room => room.photos[0] && wanted !== '' && (key(room.name).includes(wanted) || wanted.includes(key(room.name))));
    if (partial?.photos[0]) return partial.photos[0];
  }
  return photos.cover;
}

/** Oda tipi araması: her sözcük oda adında ya da pansiyonda geçmeli, Türkçe harften bağımsız. */
export function filterOffers<T extends { roomTypes: string[]; board: string }>(offers: readonly T[], query: string): T[] {
  const terms = searchKey(query).trim().split(/\s+/).filter(Boolean);
  if (!terms.length) return [...offers];
  return offers.filter(offer => { const text = searchKey(`${offer.roomTypes.join(' ')} ${offer.board}`); return terms.every(term => text.includes(term)); });
}

/** İki ISO gün arasındaki gece sayısı; geçersizse `null`. */
export function geceFarki(giris: string, cikis: string): number | null {
  const bas = Date.parse(`${giris}T00:00:00Z`);
  const son = Date.parse(`${cikis}T00:00:00Z`);
  if (!Number.isFinite(bas) || !Number.isFinite(son) || son <= bas) return null;
  return Math.round((son - bas) / 86_400_000);
}

